import * as React from 'react';
import history from "../../config/history";
import {useEffect, useState} from "react";
import LoadingModal from "../../components/bo-core/modals/LoadinModal";
import Utils from "../../Utils";
import toastr from "toastr";
import {useDispatch, useSelector} from "react-redux";
import {fetchAllBusinessObjects, createGraphQLRequest} from "../../actions/boCoreActions";
import Input from "../../components/common/Input/Input";
import {Type} from "../../InputUtils";
import * as gql from "gql-query-builder";
import {Prompt} from "react-router";

export default function RuleEngineAction(props: any) {
    const dispatch = useDispatch();
    const allTypes = useSelector((store: any) => store.boCore.allTypes);

    const [loading, setLoading] = useState<boolean>(false);
    const [currentAction, setCurrentAction] = useState<any>(null);
    const [responseHandlerOptions, setResponseHandlerOptions] = useState<any>([]);
    const [hasResponseConfiguration, setHasResponseConfiguration] = useState<boolean>(false);
    const [responseConfiguration, setResponseConfiguration] = useState<any>({});
    const [isResponseConfigurationValid, setIsResponseConfigurationValid] = useState<boolean>(true);
    const [businessObjectsOptions, setBusinessObjectsOptions] = useState<any[]>([]);
    const [isLeaving, setIsLeaving] = useState<boolean>(false);
    const [form, setForm] = useState<any>({
        active: {
            value: 1,
            valid: true,
        },
        name: {
            value: '',
            valid: true,
            errorMsg: 'Action name cannot be empty'
        },
        actionType: {
            value: null,
            valid: true,
            errorMsg: 'Action type cannot be empty'
        },
        requestType: {
            value: null,
            valid: true,
            errorMsg: 'Request type cannot be empty'
        },
        uri: {
            value: '',
            valid: true,
            errorMsg: 'Request URI cannot be empty'
        },
        headers: {
            value: {},
            valid: true
        },
        responseBodyType: {
            value:  {
                label: 'Custom',
                value: 'custom'
            },
            valid: true
        },
        responseHandler: {
            value: null,
            valid: true,
        },
        customResponseBody: {
            value: {},
            valid: true,
            errorMsg: 'Response body cannot be empty'
        },
        flat: {
            value: 0,
            valid: true,
        },
        typeKey: {
            value: null,
            valid: true,
            errorMsg: 'Type key cannot be empty'
        },
        typeAttributes: {
            value: [],
            valid: true,
            errorMsg: 'Type attributes cannot be empty'
        },
        typeRelationships: {
            value: [],
            valid: true,
            errorMsg: 'Type relationships cannot be empty'
        },
        selectedRelationship: {
            value: null,
            valid: true,
        },
        relationshipAttributes: {
            value: [],
            valid: true,
            errorMsg: 'Relationship attributes cannot be empty'
        }
    });

    const actionTypeOptions: any[] = [
        {
            label: 'Webhook',
            value: 'webhook'
        }
    ];

    const requestTypeOptions: any[] = [
        {
            label: 'GET',
            value: 'get'
        },
        {
            label: 'POST',
            value: 'post'
        },
        {
            label: 'PUT',
            value: 'put'
        },
        {
            label: 'DELETE',
            value: 'delete'
        }
    ];

    const responseBodyTypeOptions: any[] = [
        {
            label: 'Custom',
            value: 'custom'
        },
        {
            label: 'Predefined',
            value: 'predefined'
        }
    ];

    useEffect(() => {
        document.addEventListener('keydown', keydownHandler);
        const id = props.match.params['id'];
        if (id && !isNaN(Number(id))) {
            dispatch(fetchAllBusinessObjects());
            if (id !== "-1") {
                setLoading(true);
                const currentActionFields = {
                    records: [
                        "id,name,definition,active,responseHandler"
                    ]
                }
                const getCurrentActionQuery = gql.query({
                    operation: `SysRuleEngineActions(qry: "id==${id}")`,
                    fields: [currentActionFields]
                });
                createGraphQLRequest(getCurrentActionQuery, (data) => {
                    setLoading(false);
                    if (data.SysRuleEngineActions.records.length > 0) {
                        setCurrentAction(data.SysRuleEngineActions.records[0]);
                    } else {
                        toastr.error('Cannot find action with such id.');
                        history.push(`${process.env.ENV_PREFIX}/managedata?boc=${Utils.SysRuleEngineActions}`);
                    }
                }, (error) => {
                    toastr.error(error.message);
                    setLoading(false);
                });
            }
        } else {
            history.push(`${process.env.ENV_PREFIX}/managedata?boc=${Utils.SysRuleEngineActions}`);
        }
        return () => {
            document.removeEventListener('keydown', keydownHandler);
        }
    }, []);

    useEffect(() => {
        if (allTypes) {
            setBusinessObjectsOptions(allTypes.sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                return {
                    value: item.boKey,
                    label: item.name
                }
            }));

            let handlerOptions = [];
            const foundActionType = allTypes.find(type => {
                return type.boKey === Utils.SysRuleEngineActionsKey;
            });
            if (foundActionType) {
                const foundAttribute = foundActionType.attributes.find(attr => {
                    return attr.attrKey === 'responseHandler' && attr.atrbType === 'value list';
                });
                if (foundAttribute) {
                    handlerOptions = foundAttribute.attributeValues.map(item => {
                        return {
                            value: item.name,
                            label: item.name
                        }
                    });
                    setResponseHandlerOptions(handlerOptions);
                }
            }
            if (currentAction) {
                loadActionToForm(handlerOptions);
            }
        }
    }, [allTypes, currentAction]);

    const definitionAttributeSetter = (formCopy, key, value) => {
        return {
            ...formCopy,
            [key]: {
                ...formCopy[key],
                value: value ? value : ''
            }
        }
    };

    const loadActionToForm = (handlerOptions: any[]) => {
        let formCopy = JSON.parse(JSON.stringify(form));
        if (currentAction) {
            const currentActionCopy = JSON.parse(JSON.stringify(currentAction));
            const keys = Object.keys(currentActionCopy);

            keys.forEach(key => {
                if (key === 'name' || key === 'active' || key === 'responseHandler' || key === 'definition') {
                    switch (key) {
                        case 'responseHandler':
                            formCopy = {
                                ...formCopy,
                                [key]: {
                                    ...formCopy[key],
                                    value: currentActionCopy[key] && currentActionCopy[key].length > 0 ?
                                        handlerOptions.find(handlerOpt => {
                                            return handlerOpt.value === currentActionCopy[key][0];
                                        }) : null
                                }
                            };
                            break;
                        case 'definition':
                            const defObj = JSON.parse(currentActionCopy[key]);
                            Object.keys(defObj).forEach(defKey => {
                                switch (defKey) {
                                    case 'uri':
                                    case 'headers':
                                        formCopy = definitionAttributeSetter(formCopy, defKey, defObj[defKey]);
                                        break;
                                    case 'type':
                                        formCopy = definitionAttributeSetter(formCopy, 'actionType', defObj[defKey] ? actionTypeOptions.find(opt => {
                                            return opt.value === defObj[defKey]
                                        }) : null);
                                        break;
                                    case 'requestType':
                                        formCopy = definitionAttributeSetter(formCopy, defKey, defObj[defKey] ? requestTypeOptions.find(opt => {
                                            return opt.value === defObj[defKey]
                                        }) : null);
                                        break;
                                    case 'responseConfiguration':
                                        const resConfigObj = defObj[defKey];
                                        if (resConfigObj && Object.keys(resConfigObj).length > 0) {
                                            setHasResponseConfiguration(true);
                                            const hasCustomBody = Object.keys(resConfigObj).find(rcKey => rcKey === 'customBody');
                                            formCopy = definitionAttributeSetter(formCopy, 'responseBodyType',
                                                hasCustomBody ? responseBodyTypeOptions.find(e => e.value === 'custom') :
                                                    responseBodyTypeOptions.find(e => e.value === 'predefined')
                                            );
                                            if (hasCustomBody) {
                                                formCopy = definitionAttributeSetter(formCopy, 'customResponseBody', resConfigObj['customBody']);
                                            } else {
                                                // Predefined body
                                                setResponseConfiguration(resConfigObj);
                                                Object.keys(resConfigObj).forEach(configKey => {
                                                    switch (configKey) {
                                                        case 'flat':
                                                            formCopy = definitionAttributeSetter(formCopy, configKey,
                                                                resConfigObj[configKey] === true ? 1 : 0);
                                                            break;
                                                        case 'typeKey':
                                                            formCopy = definitionAttributeSetter(formCopy, configKey, {
                                                                value: resConfigObj[configKey],
                                                                label: resConfigObj[configKey]
                                                            });
                                                            break;
                                                        case 'attributes':
                                                            const typeAttributes = Object.keys(resConfigObj[configKey]).map(attr => {
                                                                return {
                                                                    value: attr,
                                                                    label: attr
                                                                }
                                                            });
                                                            formCopy = definitionAttributeSetter(formCopy, 'typeAttributes', typeAttributes);
                                                            break;
                                                        case 'relations':
                                                            const typeRelations = Object.keys(resConfigObj[configKey]).map(rel => {
                                                                return {
                                                                    value: rel,
                                                                    label: rel
                                                                }
                                                            });
                                                            formCopy = definitionAttributeSetter(formCopy, 'typeRelationships', typeRelations);
                                                            if (typeRelations.length > 0) {
                                                                formCopy = definitionAttributeSetter(formCopy, 'selectedRelationship', typeRelations[0]);
                                                                const allRelations = resConfigObj[configKey];
                                                                const firstRelation = allRelations[typeRelations[0].value];
                                                                const firstRelationAttributes = Object.keys(firstRelation.attributes).map(attr => {
                                                                    return {
                                                                        value: attr,
                                                                        label: attr
                                                                    }
                                                                })
                                                                formCopy = definitionAttributeSetter(formCopy, 'relationshipAttributes', firstRelationAttributes);
                                                            }
                                                            break;
                                                    }
                                                });
                                            }
                                        }
                                        break;
                                }
                            })
                            break;
                        default:
                            formCopy = {
                                ...formCopy,
                                [key]: {
                                    ...formCopy[key],
                                    value: currentActionCopy[key]
                                }
                            };
                    }
                }
            });
        }
        setForm(formCopy);
    }

    const constructEditDTO = () => {
        const dto: any = {};
        Object.keys(currentAction).forEach(key => {
            switch (key) {
                case 'active':
                case 'name':
                    if (currentAction[key] !== form[key].value) {
                        dto[key] = form[key].value;
                    }
                    break;
                case 'responseHandler':
                    if ((currentAction[key].length === 0 && form[key].value) ||
                        (currentAction[key].length === 1 && form[key].value && currentAction[key][0] !== form[key].value.value)) {
                        dto[key] = {replace: [form[key].value.value]};
                    }
                    if (currentAction[key].length === 1 && !form[key].value) {
                        dto[key] = {replace: []};
                    }
                    break;
                case 'definition':
                    const currentActionCopy = JSON.parse(JSON.stringify(currentAction));
                    const defObj = JSON.parse(currentActionCopy[key]);
                    let hasChanges = false;
                    if (defObj.requestType !== form.requestType.value.value) {
                        hasChanges = true;
                        defObj['requestType'] = form.requestType.value.value;
                    }
                    if (defObj.type !== form.actionType.value.value) {
                        hasChanges = true;
                        defObj['type'] = form.actionType.value.value;
                    }
                    if (defObj.uri !== form.uri.value) {
                        hasChanges = true;
                        defObj['uri'] = form.uri.value;
                    }
                    if (defObj.headers) {
                        if ((Object.keys(defObj.headers).length === 0 && Object.keys(form.headers.value).length > 1) ||
                            (Object.keys(defObj.headers).length > 1 && Object.keys(form.headers.value).length > 1 &&
                                JSON.stringify(defObj.headers) !== JSON.stringify(form.headers.value))) {
                            hasChanges = true;
                            defObj['headers'] = form.headers.value;
                        }
                        if (Object.keys(defObj.headers).length > 0 && Object.keys(form.headers.value).length === 0) {
                            hasChanges = true;
                            defObj['headers'] = {};
                        }
                    }
                    if (defObj.responseConfiguration && Object.keys(defObj.responseConfiguration).length > 0) {
                        if (hasResponseConfiguration) {
                            if (form.responseBodyType.value.value === 'custom') {
                                if (JSON.stringify(defObj.responseConfiguration) !== JSON.stringify({
                                    customBody: form.customResponseBody.value
                                })) {
                                    hasChanges = true;
                                    defObj['responseConfiguration'] = {
                                        customBody: form.customResponseBody.value
                                    };
                                }
                            } else if (form.responseBodyType.value.value === 'predefined') {
                                if (JSON.stringify(defObj.responseConfiguration) !== JSON.stringify(responseConfiguration)) {
                                    hasChanges = true;
                                    defObj['responseConfiguration'] = responseConfiguration;
                                }
                            }
                        } else {
                            hasChanges = true;
                            defObj['responseConfiguration'] = {};
                        }
                    }

                    if (hasChanges) {
                        dto[key] = defObj;
                    }
                    break;
            }
        });

        // Checks for optional attributes, that may not be included in the saved action, but to be present in the current form
        if (form.responseHandler.value && typeof Object.keys(currentAction).find(key => key === 'responseHandler') === 'undefined') {
            dto['responseHandler'] = {replace: [form.responseHandler.value.value]};
        }
        if (Object.keys(form.headers.value).length > 0) {
            if (currentAction.definition) {
                const currentActionCopy = JSON.parse(JSON.stringify(currentAction));
                const defObj = JSON.parse(currentActionCopy.definition);
                if (typeof Object.keys(defObj).find(key => key === 'headers') === 'undefined') {
                    dto['definition'] = {
                        ...defObj,
                        headers: form.headers.value
                    }
                }
            } else {
                if (dto.definition) {
                    dto.definition['headers'] = form.headers.value;
                } else {
                    dto['definition'] = {
                        headers: form.headers.value
                    }
                }
            }
        }
        if (hasResponseConfiguration) {
            let newResponseConfigurationValue: any = {};
            if (form.responseBodyType.value.value === 'custom') {
                newResponseConfigurationValue = {
                    customBody: form.customResponseBody.value
                };
            } else if (form.responseBodyType.value.value === 'predefined') {
                newResponseConfigurationValue = responseConfiguration;
            }

            if (currentAction.definition) {
                const currentActionCopy = JSON.parse(JSON.stringify(currentAction));
                const defObj = JSON.parse(currentActionCopy.definition);
                if (!defObj.responseConfiguration || (defObj.responseConfiguration && Object.keys(defObj.responseConfiguration).length === 0)) {
                    dto['definition'] = {
                        ...defObj,
                        responseConfiguration: newResponseConfigurationValue
                    }
                }
            } else {
                if (dto.definition) {
                    dto.definition['responseConfiguration'] = newResponseConfigurationValue;
                } else {
                    dto['definition'] = {
                        newResponseConfigurationValue
                    }
                }
            }
        }

        return dto;
    };

    const stringifyValues = (obj: any) => {
        let stringValues = '';
        Object.keys(obj).forEach((key, index) => {
            let val = '';
            if (key === 'responseHandler') {
                val = JSON.stringify(obj[key]).replace(/"([^"]+)":/g, '$1:');
                stringValues += `${key}: ${val}`;
            } else if (key === 'definition') {
                // JSON type
                val = JSON.stringify(obj[key]).replace(/[\""]/g, '\\"');
                stringValues += `${key}: "${val}"`;
            } else {
                if (typeof obj[key] === 'object') {
                    val = JSON.stringify(obj[key]).replace(/[\""]/g, '\\"');
                    stringValues += `${key}: "${val}"`;
                } else if (typeof obj[key] === 'number') {
                    val = obj[key];
                    stringValues += `${key}: ${val}`;
                } else {
                    val = obj[key].replace(/[\""]/g, '\\"');
                    stringValues += `${key}: "${val}"`;
                }
            }
            if (index < Object.keys(obj).length - 1) {
                stringValues += ', '
            }
        })
        return stringValues;
    }

    const onSaveAction = () => {
        if (checkFormValidity()) {
            if (props.match.params['id'] === "-1") {
                const definition = {
                    type: form.actionType.value.value,
                    uri: form.uri.value,
                    requestType: form.requestType.value.value
                };
                if (Object.keys(form.headers.value).length > 0) {
                    definition['headers'] = form.headers.value;
                }
                if (hasResponseConfiguration) {
                    if (form.responseBodyType.value.value === 'custom') {
                        definition['responseConfiguration'] = {
                            customBody: form.customResponseBody.value
                        }
                    } else if (form.responseBodyType.value.value === 'predefined') {
                        definition['responseConfiguration'] = responseConfiguration;
                    }
                }
                const createActionDTO = {
                    active: form.active.value,
                    name: form.name.value,
                    responseHandler: form.responseHandler.value ? [form.responseHandler.value.value] : [],
                    definition
                }
                setLoading(true);
                const insertActionFields = [
                    "id,name,definition,active,responseHandler"
                ];
                const insertActionMutation = gql.mutation({
                    operation: `InsertSysRuleEngineActionsRecord(record: {${stringifyValues(createActionDTO)}})`,
                    fields: insertActionFields
                });
                createGraphQLRequest(insertActionMutation, (data) => {
                    setLoading(false);
                    toastr.success("Action successfully created");
                    setCurrentAction(data.InsertSysRuleEngineActionsRecord);
                    setIsLeaving(true);
                    history.replace(`${process.env.ENV_PREFIX}/actions/${data.InsertSysRuleEngineActionsRecord.id}`);
                }, (error) => {
                    setLoading(false);
                    toastr.error(error.message);
                });
            } else {
                const dto = constructEditDTO();
                if (Object.keys(dto).length > 0) {
                    setLoading(true);
                    const updateActionFields = {
                        records: [
                            "id,name,definition,active,responseHandler"
                        ]
                    }
                    const updateActionMutation = gql.mutation({
                        operation: `UpdateSysRuleEngineActionsRecords(qry: "id==${props.match.params['id']}", maxRecordsToUpdate: 1, ${stringifyValues(dto)})`,
                        fields: [updateActionFields]
                    });
                    createGraphQLRequest(updateActionMutation, (data) => {
                        toastr.success("Action successfully updated");
                        setCurrentAction(data.UpdateSysRuleEngineActionsRecords.records[0]);
                        setLoading(false);
                    }, (error) => {
                        setLoading(false);
                        toastr.error(error.message);
                    });
                } else {
                    toastr.warning("There are no changes.");
                }
            }
        }
    }

    const onBackToList = () => {
        if (localStorage.getItem('cameFromGlobalSearch')) {
            localStorage.removeItem('cameFromGlobalSearch');
            history.push(`${process.env.ENV_PREFIX}/globalsearch`);
        } else if (localStorage.getItem('cameFromAuditLog')) {
            localStorage.removeItem('cameFromAuditLog');
            history.push(`${process.env.ENV_PREFIX}/audit-log`);
        } else {
            history.push(`${process.env.ENV_PREFIX}/managedata?boc=${Utils.SysRuleEngineActions}`);
        }
    }

    const keydownHandler = (e) => {
        if (e.ctrlKey && e.altKey && e.keyCode === 83) {
            document.getElementById('save-action-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 8) {
            document.getElementById('back-to-list-btn').click();
        }
    };

    const generateTypeAttributesValues = (valueObjects) => {
        let attributesObject = {};
        valueObjects.forEach(val => {
            if (responseConfiguration.attributes) {
                const foundKey = Object.keys(responseConfiguration.attributes).find(key => key === val.value);
                if (foundKey) {
                    attributesObject[foundKey] = responseConfiguration.attributes[foundKey];
                } else {
                    attributesObject[val.value] = null;
                }
            } else {
                attributesObject[val.value] = null;
            }
        })
        return attributesObject;
    };

    const generateTypeRelationshipValues = (valueObjects) => {
        let relationsObject = {};
        valueObjects.forEach(val => {
            if (responseConfiguration.relations) {
                const foundKey = Object.keys(responseConfiguration.relations).find(key => key === val.value);
                if (foundKey) {
                    relationsObject[foundKey] = responseConfiguration.relations[foundKey];
                } else {
                    relationsObject[val.value] = {
                        typeKey: getRelatedTypeKey(val.value),
                        attributes: {}
                    }
                }
            } else {
                relationsObject[val.value] = {
                    typeKey: getRelatedTypeKey(val.value),
                    attributes: {}
                }
            }
        })
        return relationsObject;
    };

    const generateSelectedRelationshipAttributesValues = (attributeValuesObjects) => {
        const copyOfRelations = {
            ...responseConfiguration.relations
        };
        const currentRelationObj = copyOfRelations[form.selectedRelationship.value.value];
        if (currentRelationObj) {
            let attributes = {};
            attributeValuesObjects.forEach(val => {
                const foundKey = Object.keys(currentRelationObj.attributes).find(key => key === val.value);
                if (foundKey) {
                    attributes[val.value] = currentRelationObj.attributes[val.value]
                } else {
                    attributes[val.value] = null;
                }
            });
            currentRelationObj.attributes = attributes;
        }
        return copyOfRelations;
    };

    const getRelatedTypeKey = (relKey: string) => {
        if (form.typeKey.value) {
            const foundType = allTypes.find(type => type.boKey === form.typeKey.value.value);
            if (foundType) {
                const foundRel = foundType.relationships.find(rel => rel.relKey === relKey);
                const relatedTypeId = foundRel ?
                    foundRel.fromBoClassId === foundType.id ? foundRel.toBoClassId : foundRel.fromBoClassId
                    : null;
                if (relatedTypeId) {
                    const relatedType = allTypes.find(type => type.id === relatedTypeId);
                    if (relatedType) {
                        return relatedType.boKey;
                    }
                }
            }
        }
        return null;
    };

    const onHasResponseConfigurationChange = (resVal) => {
        setHasResponseConfiguration(resVal);
        if (!resVal) {
            setResponseConfiguration({});
            setForm({
                ...form,
                responseBodyType: {
                    value:  {
                        label: 'Custom',
                        value: 'custom'
                    },
                    valid: true
                },
                customResponseBody: {
                    value: {},
                    valid: true,
                    errorMsg: 'Response body cannot be empty'
                },
                flat: {
                    value: 0,
                    valid: true,
                },
                typeKey: {
                    value: null,
                    valid: true,
                    errorMsg: 'Type key cannot be empty'
                },
                typeAttributes: {
                    value: [],
                    valid: true,
                    errorMsg: 'Type attributes cannot be empty'
                },
                typeRelationships: {
                    value: [],
                    valid: true,
                    errorMsg: 'Type relationships cannot be empty'
                },
                selectedRelationship: {
                    value: null,
                    valid: true,
                },
                relationshipAttributes: {
                    value: [],
                    valid: true,
                    errorMsg: 'Relationship attributes cannot be empty'
                }
            });
        }
    };

    const onChange = (event, id, inputType) => {
        let eventValue;
        switch (inputType) {
            case 'select':
                eventValue = event ? event : [];
                break;
            case 'inputSwitch':
                if (event.target.value === 'true') {
                    eventValue = 0
                } else {
                    eventValue = 1;
                }
                break;
            case 'jsonContainer':
                eventValue = event.updated_src;
                break;
            default: eventValue = event.target.value;
        }

        let newFormValue = {
            ...form,
            [id]: {
                ...form[id],
                value: eventValue,
                valid: true
            }
        };

        switch (id) {
            case 'typeKey':
                newFormValue = {
                    ...newFormValue,
                    typeAttributes: {
                        ...form['typeAttributes'],
                        value: [],
                        valid: true
                    },
                    typeRelationships: {
                        ...form['typeRelationships'],
                        value: [],
                        valid: true
                    },
                    selectedRelationship: {
                        value: null,
                        valid: true
                    },
                    relationshipAttributes: {
                        ...form['relationshipAttributes'],
                        value: [],
                        valid: true
                    }
                };
                setResponseConfiguration({
                    flat: form.flat.value === 1,
                    typeKey: eventValue.value,
                    attributes: {}
                });
                break;
            case 'typeAttributes':
                setResponseConfiguration({
                    ...responseConfiguration,
                    attributes: generateTypeAttributesValues(eventValue)
                });
                break;
            case 'typeRelationships':
                newFormValue = {
                    ...newFormValue,
                    selectedRelationship: {
                        ...form['selectedRelationship'],
                        value: Object.keys(generateTypeRelationshipValues(eventValue)).map(key => {
                            return {
                                value: key,
                                label: key
                            }
                        })[0],
                        valid: true
                    },
                    relationshipAttributes: {
                        ...form['relationshipAttributes'],
                        valid: true
                    }
                };
                setResponseConfiguration({
                    ...responseConfiguration,
                    relations: generateTypeRelationshipValues(eventValue)
                });
                break;
            case 'selectedRelationship':
                newFormValue = {
                    ...newFormValue,
                    relationshipAttributes: {
                        ...form['relationshipAttributes'],
                        valid: true
                    }
                };
                break;
            case 'relationshipAttributes':
                setResponseConfiguration({
                    ...responseConfiguration,
                    relations: generateSelectedRelationshipAttributesValues(eventValue)
                })
                break;
            case 'flat':
                setResponseConfiguration({
                    ...responseConfiguration,
                    flat: eventValue === 1
                });
                break;
        }

        setForm(newFormValue);
    };

    const mapRelationshipAttributes = () => {
        const attributes = responseConfiguration.relations[form.selectedRelationship.value.value].attributes;
        if (Object.keys(attributes).length > 0) {
            return Object.keys(attributes).map(attr => {
                return {
                    value: attr,
                    label: attr
                }
            })
        }
        return [];
    }

    const checkFormValidity = (): boolean => {
        const keys = Object.keys(form);
        const formCopy = JSON.parse(JSON.stringify(form));
        let formIsValid = true;
        keys.forEach((key, index) => {
            switch (key) {
                case 'name':
                case 'uri':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'actionType':
                case 'requestType':
                case 'responseBodyType':
                    if (!formCopy[key].value) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'customResponseBody':
                    if (hasResponseConfiguration && formCopy['responseBodyType'].value?.value === 'custom') {
                        if (Object.keys(formCopy[key].value).length < 1) {
                            formCopy[key].valid = false;
                            formIsValid = false;
                        }
                    }
                    break;
                case 'typeKey':
                    if (hasResponseConfiguration && formCopy['responseBodyType'].value?.value === 'predefined') {
                        if (!formCopy[key].value) {
                            formCopy[key].valid = false;
                            formIsValid = false;
                        }
                    }
                    break;
                case 'typeAttributes':
                    if (hasResponseConfiguration && formCopy['responseBodyType'].value?.value === 'predefined') {
                        if (formCopy[key].value.length < 1) {
                            formCopy[key].valid = false;
                            formIsValid = false;
                        }
                    }
                    break;
                case 'relationshipAttributes':
                    if (hasResponseConfiguration && formCopy['responseBodyType'].value?.value === 'predefined') {
                        if (formCopy['typeRelationships'].value.length > 0 &&
                            Object.keys(responseConfiguration.relations[formCopy['selectedRelationship'].value.value].attributes).length < 1) {
                            formCopy[key].valid = false;
                            formIsValid = false;
                        }
                    }
                    break;
            }
        })
        setForm(formCopy);

        if (hasResponseConfiguration && formCopy['responseBodyType'].value?.value === 'predefined') {
            if (formCopy['typeAttributes'].value.length > 0) {
                if (typeof Object.values(responseConfiguration.attributes).find(val => val === null || val === '') !== 'undefined') {
                    setIsResponseConfigurationValid(false);
                    formIsValid = false;
                }
            }
            if (formCopy['typeRelationships'].value.length > 0) {
                Object.values(responseConfiguration.relations).forEach((relValue: any) => {
                    if (Object.values(relValue.attributes).length < 1 || typeof Object.values(relValue.attributes).find(val => val === null || val === '') !== 'undefined') {
                        setIsResponseConfigurationValid(false);
                        formIsValid = false;
                    }
                })
            }
        }

        return formIsValid;
    };

    const generateTypeAttributesOptions = () => {
        if (form.typeKey.value) {
            const foundType = allTypes.find(type => type.boKey === form.typeKey.value.value);
            if (foundType) {
                return foundType.attributes.map(attr => {
                    return {
                        label: attr.attrKey,
                        value: attr.attrKey
                    }
                })
            }
        }
        return [];
    };

    const generateTypeRelationshipsOptions = () => {
        if (form.typeKey.value) {
            const foundType = allTypes.find(type => type.boKey === form.typeKey.value.value);
            if (foundType) {
                return foundType.relationships.map(rel => {
                    return {
                        label: rel.relKey,
                        value: rel.relKey
                    }
                })
            }
        }
        return [];
    };

    const generateRelationshipAttributesOptions = () => {
        if (form.selectedRelationship.value) {
            const foundType = allTypes.find(type => type.boKey === form.typeKey.value.value);
            if (foundType) {
                const foundRel = foundType.relationships.find(rel => rel.relKey === form.selectedRelationship.value.value);
                if (foundRel) {
                    return foundRel.attributes.map(attr => {
                        return {
                            label: attr.attrKey,
                            value: attr.attrKey
                        }
                    })
                }
            }
        }
        return [];
    };

    const onResponseConfigurationChange = (event) => {
        if (event.name !== 'typeKey' && event.name !== 'flat') {
            setResponseConfiguration(event.updated_src);
            setIsResponseConfigurationValid(true);
            return true;
        } else {
            // Setting the fields to their default values as workaround for this bug:
            // https://github.com/mac-s-g/react-json-view/issues/289
            setResponseConfiguration({});
            setForm({
                ...form,
                flat: {
                    value: 0,
                    valid: true,
                },
                typeKey: {
                    value: null,
                    valid: true,
                    errorMsg: 'Type key cannot be empty'
                },
                typeAttributes: {
                    value: [],
                    valid: true,
                    errorMsg: 'Type attributes cannot be empty'
                },
                typeRelationships: {
                    value: [],
                    valid: true,
                    errorMsg: 'Type relationships cannot be empty'
                },
                selectedRelationship: {
                    value: null,
                    valid: true,
                },
                relationshipAttributes: {
                    value: [],
                    valid: true,
                    errorMsg: 'Relationship attributes cannot be empty'
                }
            })
            return false;
        }
    };

    const confirmModal = (nextLocation: any) => {
        if (areThereChanges()) {
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: 'There are unsaved changes. Are you sure you want to continue?',
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            setIsLeaving(true);
                            history.push(nextLocation)
                        }
                    },
                    cancel: () => {}
                }
            });
            return false
        }
        return true
    }

    const areThereChanges = () => {
        if (isLeaving) {
            return false
        }
        if (props.match.params['id'] !== "-1") {
            if (checkFormValidity()) {
                return Object.keys(constructEditDTO()).length > 0;
            }
            return true;
        }
        return true;
    };

    return (
        <div style={{height: "100%", width: "100%"}} className="bo-core">
            <div style={{height: 50, backgroundColor: "#2D3436", display: "flex"}}
                 className="bo-core-header top-header">
                <div style={{paddingLeft: 2, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <span id="action-title" className="header-title">
                        {props.match.params['id'] === "-1" ? "Create Action" : "Update Action"}
                    </span>
                    <div className="control-buttons">
                        <button id={'save-action-btn'} onClick={onSaveAction} style={{marginRight: 5}}
                                className={"btn btn-primary"} title={'Save Action (CTRL + ALT + S)'}>
                            <i className="fas fa-save"/> <strong className={'shortcut-btn-letters'}>S</strong>ave
                        </button>
                        <button onClick={onBackToList} id={'back-to-list-btn'}
                                className={"btn btn-new-design"} title={'Back To List (CTRL + ALT + BACKSPACE)'}>
                            <i className="fas fa-backward"> Back To List</i>
                        </button>
                    </div>
                </div>
            </div>
            <div style={{
                width: "100%",
                height: '100%',
                backgroundColor: '#2D3436',
                padding: 10
            }}>
                <div style={{width: '100%', display: 'flex'}}>
                    <div style={{width: 85, marginRight: '1%'}}>
                        <Input id={'active'}
                               value={form.active.value === 1 ? "true" : "false"}
                               required={true}
                               elementType={Type.INPUT_SWITCH}
                               changed={(event) => onChange(event, 'active', 'inputSwitch')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               labelExtraClass={'fullWidthLabel'}
                               valid={form.active.valid}
                               label={'Active'}
                               elementConfig={{
                                   tabIndex: 1
                               }}
                        />
                    </div>
                    <div style={{width: '100%', marginRight: '1%'}}>
                        <Input id={'actionName'}
                               value={form.name.value}
                               required={true}
                               elementType={Type.INPUT}
                               changed={(event) => onChange(event, 'name', 'input')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.name.valid}
                               errorMsg={form.name.errorMsg}
                               label={'Action Name*'}
                               elementConfig={{
                                   placeholder: 'Action Name',
                                   tabIndex: 2
                               }}
                        />
                    </div>
                    <div style={{width: '100%'}}>
                        <Input id={'type'}
                               value={form.actionType.value}
                               required={true}
                               elementType={Type.SELECT}
                               changed={(event) => onChange(event, 'actionType', 'select')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               errorMsg={form.actionType.errorMsg}
                               valid={form.actionType.valid}
                               selectInitialPosition={false}
                               label={'Action Type*'}
                               elementConfig={{
                                   placeholder: 'Select Action Type',
                                   isMulti: false,
                                   closeMenuOnSelect: true,
                                   tabIndex: 3,
                                   options: actionTypeOptions
                               }}
                        />
                    </div>
                </div>
                <label className={'inputLabels'}>Action Request</label>
                <div style={{width: '100%', display: 'flex', background: '#2F3D43', padding: '10px 10px 0 10px', marginTop: 5}}>
                    <div style={{width: '100%', marginRight: '1%'}}>
                        <Input id={'requestType'}
                               value={form.requestType.value}
                               required={true}
                               elementType={Type.SELECT}
                               changed={(event) => onChange(event, 'requestType', 'select')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               errorMsg={form.requestType.errorMsg}
                               valid={form.requestType.valid}
                               selectInitialPosition={false}
                               label={'Type*'}
                               elementConfig={{
                                   placeholder: 'Select Request Type',
                                   isMulti: false,
                                   closeMenuOnSelect: true,
                                   tabIndex: 4,
                                   options: requestTypeOptions
                               }}
                        />
                    </div>
                    <div style={{width: '100%'}}>
                        <Input id={'uri'}
                               value={form.uri.value}
                               required={true}
                               elementType={Type.INPUT}
                               changed={(event) => onChange(event, 'uri', 'input')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.uri.valid}
                               errorMsg={form.uri.errorMsg}
                               label={'URI*'}
                               elementConfig={{
                                   placeholder: 'Request URI',
                                   tabIndex: 5
                               }}
                        />
                    </div>
                </div>
                <div style={{width: '100%', display: 'flex', background: '#2F3D43', padding: '0 10px 10px 10px', marginBottom: 5}}>
                    <div style={{width: '100%'}}>
                        <Input id={'headers'}
                               value={form.headers.value}
                               required={false}
                               elementType={Type.JSON_CONTAINER}
                               changed={(event) => onChange(event, 'headers', 'jsonContainer')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.headers.valid}
                               label={'Headers'}
                               labelExtraClass={'fullWidthLabel'}
                               elementConfig={{
                                   tabIndex: 6,
                                   src: form.headers.value,
                                   onAdd: (event => onChange(event, 'headers', 'jsonContainer')),
                                   onEdit: (event => onChange(event, 'headers', 'jsonContainer')),
                                   onDelete: (event => onChange(event, 'headers', 'jsonContainer')),
                               }}
                        />
                    </div>
                </div>
                <label className={'inputLabels'}>Action Response</label>
                <div style={{width: '100%', display: 'flex', background: '#2F3D43', marginTop: 5}}>
                    <div style={{width: !hasResponseConfiguration || (hasResponseConfiguration && form.responseBodyType.value?.value === 'custom') ? '100%' : '70%'}}>
                        <div style={{width: '100%', display: 'flex', background: '#2F3D43', padding: '10px 10px 0 10px'}}>
                            <div style={{width: hasResponseConfiguration ? 200 : 100, marginRight: '1%'}}>
                                <Input id={'hasResponseConfiguration'}
                                       value={hasResponseConfiguration ? 'true' : 'false'}
                                       required={true}
                                       elementType={Type.INPUT_SWITCH}
                                       changed={(event) => onHasResponseConfigurationChange(event.target.value !== 'true')}
                                       classNameProp={'input-full-width margin-input-for-label'}
                                       labelExtraClass={'fullWidthLabel'}
                                       valid={true}
                                       label={'Configurable'}
                                       elementConfig={{
                                           tabIndex: 7
                                       }}
                                />
                            </div>
                            {hasResponseConfiguration ?
                                <div style={{width: '100%', marginRight: '1%'}}>
                                    <Input id={'responseBodyType'}
                                           value={form.responseBodyType.value}
                                           required={true}
                                           elementType={Type.SELECT}
                                           changed={(event) => onChange(event, 'responseBodyType', 'select')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           valid={form.responseBodyType.valid}
                                           selectInitialPosition={false}
                                           label={'Body Type*'}
                                           elementConfig={{
                                               placeholder: 'Select Response Body Type',
                                               isMulti: false,
                                               closeMenuOnSelect: true,
                                               tabIndex: 7,
                                               options: responseBodyTypeOptions
                                           }}
                                    />
                                </div> : null
                            }
                            <div style={{width: '100%'}}>
                                <Input id={'responseHandler'}
                                       value={form.responseHandler.value}
                                       required={false}
                                       elementType={Type.SELECT}
                                       changed={(event) => onChange(event, 'responseHandler', 'select')}
                                       classNameProp={'input-full-width margin-input-for-label'}
                                       valid={form.responseHandler.valid}
                                       selectInitialPosition={false}
                                       label={'Response Handler'}
                                       elementConfig={{
                                           placeholder: 'Select Response Handler',
                                           isMulti: false,
                                           closeMenuOnSelect: true,
                                           tabIndex: 8,
                                           options: responseHandlerOptions
                                       }}
                                />
                            </div>
                        </div>
                        {hasResponseConfiguration && form.responseBodyType.value?.value === 'custom' ?
                            <div style={{width: '100%', display: 'flex', background: '#2F3D43', padding: '0 10px 10px 10px', marginBottom: 5}}>
                                <div style={{width: '100%'}}>
                                    <Input id={'customResponseBody'}
                                           value={form.customResponseBody.value}
                                           required={true}
                                           elementType={Type.JSON_CONTAINER}
                                           changed={(event) => onChange(event, 'customResponseBody', 'jsonContainer')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           errorMsg={form.customResponseBody.errorMsg}
                                           valid={form.customResponseBody.valid}
                                           label={'Custom Response Body*'}
                                           labelExtraClass={'fullWidthLabel'}
                                           elementConfig={{
                                               tabIndex: 9,
                                               src: form.customResponseBody.value,
                                               onAdd: (event => onChange(event, 'customResponseBody', 'jsonContainer')),
                                               onEdit: (event => onChange(event, 'customResponseBody', 'jsonContainer')),
                                               onDelete: (event => onChange(event, 'customResponseBody', 'jsonContainer'))
                                           }}
                                    />
                                </div>
                            </div> : null
                        }
                        {hasResponseConfiguration && form.responseBodyType.value?.value === 'predefined' ?
                            <React.Fragment>
                                <div style={{width: '100%', display: 'flex', background: '#2F3D43',
                                    padding: form.typeRelationships.value.length > 0 ? '0 10px 0 10px' : '0 10px 10px 10px',
                                    marginBottom: form.typeRelationships.value.length > 0 ? 0 : 5}}>
                                    <div style={{width: 85, marginRight: '1%'}}>
                                        <Input id={'flat'}
                                               value={form.flat.value === 1 ? "true" : "false"}
                                               required={true}
                                               elementType={Type.INPUT_SWITCH}
                                               changed={(event) => onChange(event, 'flat', 'inputSwitch')}
                                               classNameProp={'input-full-width margin-input-for-label'}
                                               labelExtraClass={'fullWidthLabel'}
                                               valid={form.flat.valid}
                                               label={'Flat'}
                                               elementConfig={{
                                                   tabIndex: 9
                                               }}
                                        />
                                    </div>
                                    <div style={{width: '100%', marginRight: '1%'}}>
                                        <Input id={'typeKey'}
                                               value={form.typeKey.value}
                                               required={true}
                                               elementType={Type.SELECT}
                                               changed={(event) => onChange(event, 'typeKey', 'select')}
                                               classNameProp={'input-full-width margin-input-for-label'}
                                               errorMsg={form.typeKey.errorMsg}
                                               valid={form.typeKey.valid}
                                               selectInitialPosition={false}
                                               label={'Type Key*'}
                                               elementConfig={{
                                                   placeholder: 'Select Type Key',
                                                   isMulti: false,
                                                   closeMenuOnSelect: true,
                                                   tabIndex: 10,
                                                   options: businessObjectsOptions
                                               }}
                                        />
                                    </div>
                                    <div style={{width: '100%', marginRight: '1%'}}>
                                        <Input id={'typeAttributes'}
                                               value={form.typeAttributes.value}
                                               required={true}
                                               elementType={Type.SELECT}
                                               changed={(event) => onChange(event, 'typeAttributes', 'select')}
                                               classNameProp={'input-full-width margin-input-for-label'}
                                               errorMsg={form.typeAttributes.errorMsg}
                                               valid={form.typeAttributes.valid}
                                               selectInitialPosition={false}
                                               label={'Type Attributes*'}
                                               elementConfig={{
                                                   placeholder: 'Select Type Attributes',
                                                   isMulti: true,
                                                   closeMenuOnSelect: false,
                                                   tabIndex: 11,
                                                   options: generateTypeAttributesOptions(),
                                                   readOnlyInput: form.typeKey.value === null
                                               }}
                                        />
                                    </div>
                                    <div style={{width: '100%'}}>
                                        <Input id={'typeRelationships'}
                                               value={form.typeRelationships.value}
                                               required={true}
                                               elementType={Type.SELECT}
                                               changed={(event) => onChange(event, 'typeRelationships', 'select')}
                                               classNameProp={'input-full-width margin-input-for-label'}
                                               errorMsg={form.typeRelationships.errorMsg}
                                               valid={form.typeRelationships.valid}
                                               selectInitialPosition={false}
                                               label={'Type Relationships'}
                                               elementConfig={{
                                                   placeholder: 'Select Type Relationships',
                                                   isMulti: true,
                                                   closeMenuOnSelect: false,
                                                   tabIndex: 12,
                                                   options: generateTypeRelationshipsOptions(),
                                                   readOnlyInput: form.typeKey.value === null
                                               }}
                                        />
                                    </div>
                                </div>
                                {responseConfiguration && responseConfiguration.relations && Object.keys(responseConfiguration.relations).length > 0 ?
                                    <div style={{width: '100%', display: 'flex', background: '#2F3D43', padding: '0 10px 10px 10px', marginBottom: 5}}>
                                        <div style={{width: '100%', marginRight: '1%'}}>
                                            <Input id={'selectedRelationship'}
                                                   value={form.selectedRelationship.value}
                                                   required={true}
                                                   elementType={Type.SELECT}
                                                   changed={(event) => onChange(event, 'selectedRelationship', 'select')}
                                                   classNameProp={'input-full-width margin-input-for-label'}
                                                   valid={form.selectedRelationship.valid}
                                                   selectInitialPosition={false}
                                                   label={'Relationship'}
                                                   elementConfig={{
                                                       placeholder: 'Select Relationship',
                                                       isMulti: false,
                                                       closeMenuOnSelect: true,
                                                       tabIndex: 13,
                                                       options: Object.keys(responseConfiguration.relations).map(key => {
                                                           return {
                                                               value: key,
                                                               label: key
                                                           }
                                                       })
                                                   }}
                                            />
                                        </div>
                                        {form.selectedRelationship.value ?
                                            <div style={{width: '100%'}}>
                                                <Input id={'relationshipAttributes'}
                                                       value={mapRelationshipAttributes()}
                                                       required={true}
                                                       elementType={Type.SELECT}
                                                       changed={(event) => onChange(event, 'relationshipAttributes', 'select')}
                                                       classNameProp={'input-full-width margin-input-for-label'}
                                                       errorMsg={form.relationshipAttributes.errorMsg}
                                                       valid={form.relationshipAttributes.valid}
                                                       selectInitialPosition={false}
                                                       label={'Relationship Attributes*'}
                                                       elementConfig={{
                                                           placeholder: 'Select Relationship Attributes',
                                                           isMulti: true,
                                                           closeMenuOnSelect: false,
                                                           tabIndex: 14,
                                                           options: generateRelationshipAttributesOptions()
                                                       }}
                                                />
                                            </div> : null}
                                    </div> : null
                                }
                            </React.Fragment> : null
                        }
                    </div>
                    {hasResponseConfiguration && form.responseBodyType.value?.value === 'predefined' ?
                        <div style={{width: '30%', padding: '10px 10px 0 10px'}}>
                            <Input id={'responseConfiguration'}
                                   value={responseConfiguration}
                                   required={true}
                                   elementType={Type.JSON_CONTAINER}
                                   changed={(event) => onResponseConfigurationChange(event)}
                                   classNameProp={'input-full-width margin-input-for-label'}
                                   valid={isResponseConfigurationValid}
                                   errorMsg={"Attributes' values cannot be null or empty string"}
                                   label={'Response Configuration (You can only update attribute values)'}
                                   labelExtraClass={'fullWidthLabel'}
                                   elementConfig={{
                                       tabIndex: 15,
                                       src: responseConfiguration,
                                       onEdit: onResponseConfigurationChange,
                                       validationMessage: 'You can only update attribute values!'
                                   }}
                            />
                        </div> : null
                    }
                </div>
            </div>
            <LoadingModal open={loading}/>
            <Prompt message={confirmModal}/>
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/views/bo-core/RuleEngineAction.tsx